var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotReferral(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_493_219)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75684 11.8477C5.75684 12.6897 6.09135 13.4973 6.68679 14.0928C7.28223 14.6882 8.08981 15.0227 8.93189 15.0227C9.77397 15.0227 10.5816 14.6882 11.177 14.0928C11.7724 13.4973 12.1069 12.6897 12.1069 11.8477C12.1069 11.0062 11.7727 10.1991 11.1776 9.60411C10.5826 9.00909 9.77558 8.6748 8.93409 8.6748C8.09259 8.6748 7.28557 9.00909 6.69054 9.60411C6.09551 10.1991 5.76123 11.0062 5.76123 11.8477H5.75684ZM11.0479 15.0249H6.81592C5.07129 15.0249 3.64307 15.9741 3.64307 17.1387V19.2568H14.2251V17.1387C14.2251 15.9741 12.7969 15.0249 11.0479 15.0249Z",
    fill: "#D32F2F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0103 16.7827H17.4463V23.9063H26.3584V20.3467C26.3584 18.3867 23.9502 16.7827 21.0103 16.7827Z",
    fill: "#D32F2F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4463 16.7827H17.4551C18.8464 16.744 20.1679 16.1644 21.1387 15.1669C22.1095 14.1695 22.6532 12.8329 22.6544 11.441C22.6555 10.0492 22.114 8.71166 21.1448 7.71266C20.1756 6.71365 18.8551 6.13184 17.4639 6.09082H17.4463V16.7827Z",
    fill: "#D32F2F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4463 16.7827V23.9063H8.53418V20.3467C8.53418 18.3867 10.9424 16.7827 13.8823 16.7827H17.4463Z",
    fill: "#EF5350"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0981 11.4346C12.0981 14.3877 14.4932 16.7827 17.4463 16.7827V6.09082C14.4932 6.09082 12.0981 8.48145 12.0981 11.4346Z",
    fill: "#EF5350"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.02881 17.187L5.77002 19.3403H7.05762C7.38281 21.4981 8.99121 22.4209 10.604 22.7285C9.47461 21.9595 8.96045 20.8828 8.96045 19.3447H10.2788L8.02881 17.187Z",
    fill: "#FBC02D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_493_219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotReferral);
export default __webpack_public_path__ + "static/media/not-referral.89c893d6613164f9d9e6ffe1c09e2dde.svg";
export { ForwardRef as ReactComponent };